"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const branding_1 = require("src/context/branding");
const special_options_as_buttons_1 = __importDefault(require("src/components/special-options-as-buttons"));
const question_1 = __importDefault(require("../question"));
const question_rating_styles_1 = __importDefault(require("./question-rating.styles"));
const b = b_1.default.with('rating');
const WIDTH_STAR = 36;
const HEIGHT_STAR = 38;
function Rating(props) {
    const { handleClickOption, id, options, children, noOpinionAnswer, handleClickNoOpinionAnswer } = props, rest = __rest(props, ["handleClickOption", "id", "options", "children", "noOpinionAnswer", "handleClickNoOpinionAnswer"]);
    const branding = (0, branding_1.useBrandingContext)();
    const { rating: { borderWidth = 2, colors: { borderActive = 'transparent', borderInactive = '#B9B9B9', fillActive = '#fc0', fillInactive = 'white' } = {} } = {} } = branding || {};
    let indexSelected;
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_rating_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b({ stars: options.length }) }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('container') }, { children: options
                        .slice()
                        .reverse()
                        .map((option, index) => {
                        // Тут reverse, так как в css direction: rtl;
                        // Костыляем из-за бага в старых андроидах
                        // https://st.yandex-team.ru/PYTHIADEV-100
                        if (option.checked) {
                            indexSelected = index;
                        }
                        const active = indexSelected <= index;
                        const classes = b('option', { active });
                        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrapper') }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ className: classes, "data-value": option.id }, { children: [(0, jsx_runtime_1.jsx)("svg", Object.assign({ width: `${WIDTH_STAR}px`, height: `${HEIGHT_STAR}px`, viewBox: `0 0 ${WIDTH_STAR} ${HEIGHT_STAR}`, fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: (0, jsx_runtime_1.jsx)("path", { d: 'M18 0L23.1733 10.8795L35.119 12.4377L26.3706 20.7198L28.5801\n                                                32.5623L18 26.8014L7.41987 32.5623L9.62938 20.7198L0.880983 12.4377L12.8267 10.8795L18 0Z', stroke: active ? borderActive : borderInactive, strokeWidth: borderWidth, fill: active ? fillActive : fillInactive, fillOpacity: 1 }) })), (0, jsx_runtime_1.jsx)("input", { type: 'radio', checked: option.checked, "data-index": id, value: option.id, onClick: handleClickOption, className: b('input') })] })) }), option.id));
                    }) })) })), (0, jsx_runtime_1.jsx)(special_options_as_buttons_1.default, { theme: props.theme, noOpinionAnswer: noOpinionAnswer, otherAnswer: props.otherAnswer, otherAnswerWithText: props.otherAnswerWithText, handleChangeOtherWithText: props.handleChangeOtherWithText, handleClickNoOpinionAnswer: handleClickNoOpinionAnswer, handleClickOther: props.handleClickOther, handleClickOtherWithText: props.handleClickOtherWithText, handleBlurOtherWithText: props.handleBlurOtherWithText }), children] })));
}
exports.default = Rating;
Rating.defaultProps = {
    handleClickOption: () => { },
    options: [],
    id: 0,
    handleClickNoOpinionAnswer: () => { },
    noOpinionAnswer: {
        enabled: false,
        label: '',
        checked: false
    },
    children: []
};
